<script setup lang="ts">
import NavigationLinks from './layout-elements/NavigationLinks.vue';

import { ModuleKey } from '@nxtpeople/nxt-vue-library';

//#region Globals
const { state, commit } = useStore();
const route = useRoute();
//#endregion

//#region Board Id
const board_id = computed(() => route.query.board_id?.toString());

function updateBoard(board_id?: string) {
   if (board_id) return;
   commit('board/setBoard', undefined);
}

watch(board_id, updateBoard);
//#endregion

// #region space
const space_name = computed(() => {
   return state.space?.space?.name || JSON.parse(localStorage.getItem('space') || '{}')?.name;
});
// #endregion
</script>

<template>
   <NxtSidebar :module-key="ModuleKey.NxtPlan">
      <template #navigation>
         <NavigationLinks />
      </template>

      <template #navigationFooter>
         <RouterLink v-if="space_name" :to="{ name: 'board-overview' }" :class="['mainbar__space']">
            <div class="mainbar__space__circle">
               <span class="mainbar__space__circle__label">{{ space_name?.[0]?.toUpperCase() }}</span>
            </div>
            <span>{{ $t('global.boards', 2) }}</span>
         </RouterLink>
      </template>
   </NxtSidebar>
</template>

<style lang="scss" scoped>
.mainbar__space {
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: var(--nxt-gutter);
   padding: 0 var(--nxt-gutter-small);
}

.mainbar__space__circle {
   display: flex;
   justify-content: center;
   align-items: center;

   height: toRem(25);
   width: toRem(25);

   border: 1px solid var(--nxt-brand-primary);
   border-radius: 50%;
}

.mainbar__space__circle__label {
   font-size: var(--nxt-font-base);
}
</style>
